























import { computed, defineComponent, PropType, ref } from "@vue/composition-api";
import { ContentPurchase } from "@scrile/api-provider/dist/api/ContentPriceProvider";
import {
  FundraisingGoal,
  FundraisingGoalReward,
  FundraisingGoalRewardPurchaseDetails,
  FundraisingGoalRewardStatus,
} from "@scrile/api-provider/dist/api/FundraisingGoalsProvider";
import providers from "@/lib/api";
import BaseSpinner from "@/components/BaseSpinner";
import FundraisingGoalRewardCard from "@/components/FundraisingGoal/FundraisingGoalRewardCard";
import RewardPurchaseModal from "./RewardPurchaseModal.vue";

export default defineComponent({
  name: "RewardsList",
  components: { RewardPurchaseModal, FundraisingGoalRewardCard, BaseSpinner },
  props: {
    goal: { type: Object as PropType<FundraisingGoal>, required: true },
    isAuthor: { type: Boolean, required: true },
  },
  setup(props) {
    const loading = ref(false);
    const rewards = ref<FundraisingGoalReward[]>([]);
    const rewardToPurchase = ref<FundraisingGoalReward | null>(null);

    const sortedRewards = computed(() => rewards.value.sort((a, b) => a.amount - b.amount));

    const onPurchased = (data: ContentPurchase<FundraisingGoalRewardPurchaseDetails>) => {
      rewardToPurchase.value = null;
      rewards.value = rewards.value.map(item => (item.id === data.content.reward.id ? data.content.reward : item));
    };

    const getData = async () => {
      loading.value = true;
      try {
        const response = await providers.FundraisingGoalsProvider.rewardSearch({
          data: { goalId: props.goal.id, statuses: [FundraisingGoalRewardStatus.ACTIVE], size: 2000 },
        });
        rewards.value = response.result;
      } finally {
        loading.value = false;
      }
    };

    getData();

    return {
      loading,
      sortedRewards,
      rewardToPurchase,
      onPurchased,
    };
  },
});
